import React, { useState } from 'react';
import { Search, Filter, MapPin, Globe, Mail } from 'lucide-react';
export function CommunityPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const members = [{
    id: 1,
    name: 'Sarah Jenkins',
    company: 'Spark Station',
    industry: 'EdTech',
    location: 'Toronto, ON',
    initials: 'SJ',
    color: 'bg-blue-600',
    tagline: 'Empowering the next generation through immersive STEM learning experiences.',
    logo: 'https://cdn.magicpatterns.com/uploads/kT5n552sA1fwaoDotd154A/WhatsApp_Image_2025-08-14_at_07.51.30_(1).jpg'
  }, {
    id: 2,
    name: 'David Okoye',
    company: 'HealthSync',
    industry: 'HealthTech',
    location: 'Vancouver, BC',
    initials: 'DO',
    color: 'bg-emerald-600',
    tagline: 'Connecting patients with culturally competent care providers.'
  }, {
    id: 3,
    name: 'Amara Diallo',
    company: 'Lumina Beauty',
    industry: 'Consumer Goods',
    location: 'Montreal, QC',
    initials: 'AD',
    color: 'bg-purple-600',
    tagline: 'Clean, inclusive skincare formulated for melanin-rich skin.'
  }, {
    id: 4,
    name: 'Marcus Johnson',
    company: 'FinEdge',
    industry: 'FinTech',
    location: 'Calgary, AB',
    initials: 'MJ',
    color: 'bg-catalyst-mustard-dark',
    tagline: 'Democratizing access to alternative investment vehicles.'
  }, {
    id: 5,
    name: 'Chloe Mensah',
    company: 'EduPlay',
    industry: 'EdTech',
    location: 'Halifax, NS',
    initials: 'CM',
    color: 'bg-pink-600',
    tagline: 'Gamified STEM learning platforms for early childhood education.'
  }, {
    id: 6,
    name: 'Jamal Peters',
    company: 'GreenLogistics',
    industry: 'Supply Chain',
    location: 'Toronto, ON',
    initials: 'JP',
    color: 'bg-green-700',
    tagline: 'Sustainable last-mile delivery solutions for urban centers.'
  }, {
    id: 7,
    name: 'Nia Washington',
    company: 'Aura Analytics',
    industry: 'Data Analytics',
    location: 'Ottawa, ON',
    initials: 'NW',
    color: 'bg-indigo-600',
    tagline: 'Predictive AI models for retail inventory management.'
  }, {
    id: 8,
    name: 'Elijah Brooks',
    company: 'BuildRight',
    industry: 'PropTech',
    location: 'Edmonton, AB',
    initials: 'EB',
    color: 'bg-orange-600',
    tagline: 'Platform connecting diverse contractors with commercial developers.'
  }];
  return <div className="space-y-8 animate-in fade-in duration-500" data-id="element-342">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4 border-b border-gray-200 pb-6" data-id="element-343">
        <div data-id="element-344">
          <h1 className="text-3xl font-heading font-bold text-catalyst-black tracking-tight" data-id="element-345">
            Cohort Directory
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-346">
            Connect with your fellow founders in Cohort 1
          </p>
        </div>

        <div className="flex gap-3 w-full md:w-auto" data-id="element-347">
          <div className="relative flex-1 md:w-64" data-id="element-348">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-349" />
            <input type="text" placeholder="Search founders, companies..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-catalyst-mustard/50 focus:border-catalyst-mustard transition-all text-sm shadow-sm" data-id="element-350" />
          </div>
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors shadow-sm" data-id="element-351">
            <Filter size={16} data-id="element-352" />
            <span className="hidden sm:inline" data-id="element-353">Filter</span>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-354">
        {members.map(member => <div key={member.id} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md hover:border-catalyst-mustard/30 transition-all group flex flex-col h-full" data-id="element-355">
            <div className="p-6 flex-1 flex flex-col" data-id="element-356">
              <div className="flex justify-between items-start mb-4" data-id="element-357">
                {member.logo ? <img src={member.logo} alt={`${member.company} logo`} className="w-12 h-12 rounded-full object-cover shadow-sm" data-id="element-358" /> : <div className={`w-12 h-12 rounded-full ${member.color} flex items-center justify-center text-white font-bold text-lg shadow-sm`} data-id="element-359">
                    {member.initials}
                  </div>}
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 border border-gray-200" data-id="element-360">
                  {member.industry}
                </span>
              </div>

              <div className="mb-4" data-id="element-361">
                <h3 className="text-lg font-bold text-catalyst-black group-hover:text-catalyst-mustard-dark transition-colors" data-id="element-362">
                  {member.name}
                </h3>
                <p className="text-sm font-semibold text-gray-600" data-id="element-363">
                  {member.company}
                </p>
              </div>

              <p className="text-sm text-gray-500 mb-6 flex-1 line-clamp-3" data-id="element-364">
                "{member.tagline}"
              </p>

              <div className="space-y-2 mt-auto pt-4 border-t border-gray-100" data-id="element-365">
                <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-366">
                  <MapPin size={14} className="text-gray-400" data-id="element-367" />
                  {member.location}
                </div>
              </div>
            </div>

            <div className="bg-gray-50 px-6 py-3 border-t border-gray-100 flex justify-between items-center" data-id="element-368">
              <button className="text-xs font-medium text-catalyst-black hover:text-catalyst-mustard-dark transition-colors flex items-center gap-1" data-id="element-369">
                View Profile
              </button>
              <div className="flex gap-2" data-id="element-370">
                <button className="p-1.5 text-gray-400 hover:text-catalyst-mustard-dark hover:bg-white rounded-md transition-all" data-id="element-371">
                  <Mail size={16} data-id="element-372" />
                </button>
                <button className="p-1.5 text-gray-400 hover:text-catalyst-mustard-dark hover:bg-white rounded-md transition-all" data-id="element-373">
                  <Globe size={16} data-id="element-374" />
                </button>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}